import React__default from 'react';
import { View } from 'react-native';
import { A as AppAvatar } from './index-ec953df8.esm.js';

const AppAvatarList = _ref => {
  let {
    namesList,
    labelProperty = "label",
    avatarSize,
    avatarRatio,
    wrapperStyle
  } = _ref;
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flexDirection: "row"
    }, wrapperStyle]
  }, namesList === null || namesList === void 0 ? void 0 : namesList.map((n, i) => /*#__PURE__*/React__default.createElement(AppAvatar, {
    ratio: avatarRatio,
    key: i,
    label: n[labelProperty],
    size: avatarSize
  })));
};
AppAvatarList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppAvatarList",
  "props": {
    "labelProperty": {
      "defaultValue": {
        "value": "\"label\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Property to use to display values on the UI"
    },
    "namesList": {
      "required": true,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": "Items to be displayed as a list of Avatars"
    },
    "avatarSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Size of the Avatars in the list"
    },
    "avatarRatio": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Ratio between the size of the Avatar and the text"
    },
    "wrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply to the Avatar list"
    }
  }
};

export { AppAvatarList as A };
